import React from "react";

import { colors } from "@zapalacorp/tokens";
import { useTranslation } from "react-i18next";

import BadgeStatus from "../../../../../../../components/Generic/BadgeStatus";
import Breadcrumb from "../../../../../../../components/Generic/Breadcrump";
import TitlePage from "../../../../../../../components/TitlePage";
import { PRIVATE_ROUTES } from "../../../../../../../constants";
import { ShipmentStatus } from "../../../../../../../util/enums";
import BadgeShipmentTrackingStatus from "../../../../../ShipmentTracking/components/BadgeShipmentStatus";
import { ShipmentStatusTitle, ShipmentStatusWrapper } from "./styles";
import _ from "lodash";
import { isMoving } from "Util/validation";
import { useAppState } from "Context/StateContext";

interface WaybillTitleProps {
  isEditing?: boolean;
  hasMarineTrafficId?: boolean;
  shipmentId?: string;
  status?: string;
}

export default function WaybillTitle(props: WaybillTitleProps) {
  const { isEditing = false, hasMarineTrafficId = false, status = "", shipmentId } = props;
  const { t: translate } = useTranslation();
  const { currentUser } = useAppState();

  const onSetWaybillStatus = () => {
    if (isEditing) {
      return status;
    }

    return ShipmentStatus.DRAFT;
  };

  const onSetLeftSide = () => {
    const subtitle = isEditing ? translate("editShipment") : translate("newShipment");

    if (isMoving(currentUser?.company)) {
      return (
        <Breadcrumb
          items={[
            {
              title: subtitle,
              color: colors.gray800,
              dataCy: "waybillTitle",
            },
          ]}
        />
      );
    }

    return (
      <Breadcrumb
        items={[
          {
            title: translate("shipments"),
            link: {
              url: PRIVATE_ROUTES.SHIPMENTS,
            },
          },
          {
            title: subtitle,
            color: colors.gray800,
            dataCy: "waybillTitle",
          },
        ]}
      />
    );
  };

  const onSetRightSide = () => (
    <ShipmentStatusWrapper>
      {!_.isEmpty(shipmentId) ? (
        <ShipmentStatusTitle data-cy="title-page-customer">{`#${shipmentId}`}</ShipmentStatusTitle>
      ) : (
        <></>
      )}

      {hasMarineTrafficId ? (
        <BadgeShipmentTrackingStatus value={onSetWaybillStatus()} />
      ) : (
        <BadgeStatus value={onSetWaybillStatus()} />
      )}
    </ShipmentStatusWrapper>
  );

  return <TitlePage left={onSetLeftSide()} right={onSetRightSide()} />;
}
